import { render } from "./prescriptions_tab.vue?vue&type=template&id=38741d28"
import script from "./prescriptions_tab.vue?vue&type=script&lang=js"
export * from "./prescriptions_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__